howspace.mediaRecorder = (() => {
    'use strict';

    let stream;
    let recorder;

    /**
     * Destroy the recorder and stop the stream
     */
    const destroy = () => {
        if (stream) {
            stream.getTracks().forEach(function (track) {
                track.stop();
            });
        }

        if (recorder) {
            recorder.destroy();
            recorder = null;
        }
    };

    /**
     *
     * @param {*} onStartFn
     * @param {*} onErrorFn
     */
    const startAudio = (onStartFn, onErrorFn) => {
        disableRecordingButtons();

        const handleSuccess = (_stream) => {
            onStartFn(_stream, 'audio');
        };

        const handleError = (error) => {
            enableRecordingButtons();
            onErrorFn(error);
        }

        navigator.mediaDevices.getUserMedia({ audio: true, video: false }).then(handleSuccess).catch(handleError);
    };

    /**
     *
     * @param {*} videoElem
     * @param {*} onStartFn
     * @param {*} onErrorFn
     */
    const startVideo = (videoElem, onStartFn, onErrorFn) => {
        disableRecordingButtons();

        const handleSuccess = (_stream) => {
            // Pass the stream to the video element
            videoElem.srcObject = _stream;
            // Call the onStartFn callback
            onStartFn(_stream, 'video');
        };

        const handleError = (error) => {
            enableRecordingButtons();
            onErrorFn(error);
        }

        navigator.mediaDevices.getUserMedia({ audio: true, video: true }).then(handleSuccess).catch(handleError);
    };

    const disableRecordingButtons = () => {
        $('.widget .record-audio-btn').prop('disabled', true).addClass('disabled');
        $('.widget .record-video-btn').prop('disabled', true).addClass('disabled');
    }

    const enableRecordingButtons = () => {
        $('.widget .record-audio-btn').prop('disabled', false).removeClass('disabled');
        $('.widget .record-video-btn').prop('disabled', false).removeClass('disabled');
    }

    /*
    * Start recording audio or video depending on the provided type
    * @param MediaStream s
    * @param String type
    */
    const start = async (s, type) => {
        howspace.activityTracker.setRecording(true);
        await lib('recordrtc', 'RecordRTC.min.js', false);
        stream = s;
        recorder = RecordRTC(s, {
            type: type
        });
        recorder.startRecording();
    }

    /**
     * Stop the recording
     * @param {*} stopFn
     */
    const stop = (stopFn) => {
        howspace.activityTracker.setRecording(false);
        enableRecordingButtons();
        if (recorder) {
            recorder.stopRecording(() => {
                stream.getTracks().forEach((track) => {
                    track.stop();
                });

                if (stopFn) {
                    stopFn(recorder.getBlob());
                }
            });
        }
    };

    const calculateTime = (milliseconds) => {
        let x, seconds, minutes, hours;
        x = milliseconds / 1000;
        seconds = real.pad(Math.floor(x % 60));
        x /= 60;
        minutes = real.pad(Math.floor(x % 60));
        x /= 60;
        hours = real.pad(Math.floor(x % 24));
        return { hours, minutes, seconds };
    };

    const formatTime = (hours, minutes, seconds) => {
        let format = `${minutes}:${seconds}`;
        if (hours > 0) {
            format = `${hours}:${format}`;
        }
        return format;
    };

    const checkAudio = async () => {
        if (typeof navigator.permissions === 'undefined') {
            // Teams Android client does not support navigator.permissions
            return true;
        }

        try {
            const result = await navigator.permissions.query({ name: 'microphone' });
            return result.state === 'granted' || result.state === 'prompt';
        } catch (error) {
            return false;
        }
    };

    const checkVideo = async () => {
        if (typeof navigator.permissions === 'undefined') {
            // Teams Android client does not support navigator.permissions
            return true;
        }

        try {
            const result = await navigator.permissions.query({ name: 'camera' });
            return result.state === 'granted' || result.state === 'prompt';
        } catch (error) {
            return false;
        }
    };

    const getFileExtension = (blob) => {
        const mimeType = (blob.type || '').split(';')[0].toLowerCase();

        const mimeToExtension = {
            'video/webm': '.webm',
            'video/mp4': '.mp4',
            'video/ogg': '.ogv',
            'video/quicktime': '.mov',
            'video/x-matroska': '.mkv',

            'audio/webm': '.webm',
            'audio/mpeg': '.mp3',
            'audio/ogg': '.ogg',
            'audio/wav': '.wav',
            'audio/mp4': '.m4a',
            'audio/x-m4a': '.m4a',
            'audio/aac': '.aac'
        };

        if (!mimeType) {
            throw new Error('Recording blob is missing MIME type');
        }

        if (!mimeToExtension[mimeType]) {
            throw new Error(`Unsupported MIME type: ${mimeType}`);
        }

        return mimeToExtension[mimeType];
    };

    return {
        destroy: destroy,
        startAudio: startAudio,
        startVideo: startVideo,
        start: start,
        stop: stop,
        calculateTime: calculateTime,
        formatTime: formatTime,
        checkAudio : checkAudio,
        checkVideo : checkVideo,
        getFileExtension
    };

})();
